<template>
  <div class="avatar-upload">
    <div class="avatar-content position-relative">
      <div v-if="loading" class="position-absolute d-flex justify-content-center align-items-center" style="width: 8rem; height: 100%; background-color: rgba(0,0,0,.5);">
        <div class="spinner-border text-light" style="width: 3rem; height: 3rem;" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <label class="upload-area">
        <img :src="this.fileUrl" class="avatar-img" alt="Avatar" v-if="fileUrl" />
        <i class="ri-upload-2-line ri-lg" v-else></i>
        <input id="avatar" type="file" name="avatar" ref="avatar" @change="onUpload()" style="display: none;" />
        <input :value="fileName" type="text" name="avatar_file" style="display: none;">
      </label>
      <div class="label-wrapper">
        <div class="label">{{ label }} *</div>
      </div>
    </div>
    <div class="avatar-error">
      <slot name="error">
        {{ error }}
      </slot>
    </div>
  </div>
</template>

<script>
import Compressor from 'compressorjs';
import { upload } from '../utils/s3';

export default {
  props: {
    label: String,
    avatarValue: String,
  },

  data () {
    return {
      availableFileType: [
        'image/jpeg',
        'image/png',
        'image/bmp'
      ],
      file: '',
      fileUrl: '',
      fileName: '',
      error: '',
      beforeCompressSize: 0,
      afterCompressSize: 0,
      loading: false,
      submitBtn: '',
      btnStartState: ''
    }
  },

  mounted() {
    const submitBtn = document.getElementById('submit-btn')

    if (submitBtn) {
      this.submitBtn = submitBtn
      this.btnStartState = `${submitBtn.innerHTML}`
    }

    if (this.avatarValue) {
      this.fileUrl = this.avatarValue
    }
  },

  watch: {
    loading() {
      const oldState = `${this.submitBtn.innerHTML}`

      if (this.loading) {
        this.submitBtn.innerHTML = `
          <span class="d-flex justify-content-center align-items-center">
            <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
            Chargement du fichier...
          </span>
        `
        this.submitBtn.disabled = true
      } else {
        this.submitBtn.innerHTML = this.btnStartState
        this.submitBtn.disabled = false
      }
    }
  },

  methods: {
    onUpload() {
      const file = this.$refs.avatar.files[0]

      if (file) {
        if (this.isGoodFileType(file.type)) {
          if (file.size < 5000000) {
            const self = this
            this.beforeCompressSize = file.size
            this.loading = true
            new Compressor(file, {
              convertSize: 500000,
              success(result) {
                const fileExtension =  result.name.split('.').pop()
                const fileName = `${Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)}.${fileExtension}`

                console.log('Uploading...')

                upload(result, fileName, true)
                  .then((data) => {
                    self.error = ''
                    self.file = result
                    self.fileUrl = data.Location
                    self.fileName = data.Key
                    self.afterCompressSize = result.size

                    self.loading = false
                  })
                  .catch((err) => {
                    self.error = 'Une erreur s\'est produite pendant l\'envoi'
                    self.clearFile()
                    self.loading = false
                  })
              },
              error(err) {
                self.clearFile()
                self.error = 'Une erreur c\'est produite pendant la compréssion du fichier.'
              },
            })
          } else {
            this.clearFile()
            this.error = 'Le poids du fichier est trop gros. 5 Mo maximum.'
          }
        } else {
          this.clearFile()
          this.error = 'Le champ photo de profil doit être une image. jpeg, png, bmp uniquement.'
        }
      }
    },

    clearFile() {
      this.$refs.avatar.value = ''
      this.file = ''
      this.fileUrl = ''
      this.fileName = ''
    },

    isGoodFileType(type) {
      return this.availableFileType.indexOf(type) != -1;
    },

    compressFile() {
      new Compressor(file, {
        quality: 0.6,
        success(result) {
          const formData = new FormData();

          // The third parameter is required for server
          formData.append('file', result, result.name);

          // Send the compressed image file to server with XMLHttpRequest.
          axios.post('/path/to/upload', formData).then(() => {
            console.log('Upload success');
          });
        },
        error(err) {
          console.log(err.message)
        },
      })
    }
  }
}
</script>
